// Date 2021-03-19 18:47:32

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import sithMesStoolPrList from "@/views/sithMes/stool/SithMesStoolPrList.vue";
import sithMesStoolPrEdit from "@/views/sithMes/stool/SithMesStoolPrEdit.vue";
import sithMesStoolOpenPrList from "@/views/sithMes/stool/SithMesStoolOpenPrList.vue";
import sithMesStoolOpenPrOmList from "@/views/sithMes/stool/SithMesStoolOpenPrOmList.vue";
import sithMesStoolOpenPrEdit from "@/views/sithMes/stool/SithMesStoolOpenPrEdit.vue";
import sithMesStoolProblematicPrEdit from "@/views/sithMes/stool/SithMesStoolProblematicPrEdit.vue";
import sithMesStoolProblematicPrList from "@/views/sithMes/stool/SithMesStoolProblematicPrList.vue";
import sithMesStoolHandleProblematicPrList from "@/views/sithMes/stool/SithMesStoolHandleProblematicPrList.vue";
import sithMesStoolPrPriceEdit from "@/views/sithMes/stool/SithMesStoolPrPriceEdit.vue";
import sithMesStoolPrAskPriceList from "@/views/sithMes/stool/SithMesStoolPrAskPriceList.vue";
import sithMesStoolPrHistoryPriceList from "@/views/sithMes/stool/SithMesStoolPrHistoryPriceList.vue";
import sithMesStoolPrPriceList from "@/views/sithMes/stool/SithMesStoolPrPriceList.vue";
import sithMesStoolPoList from "@/views/sithMes/stool/SithMesStoolPoList.vue";
import sithMesStoolTotalPoList from "@/views/sithMes/stool/SithMesStoolTotalPoList.vue";
import sithMesStoolTotalVendorPoList from "@/views/sithMes/stool/SithMesStoolTotalVendorPoList.vue";
import sithMesStoolKpiList from "@/views/sithMes/stool/SithMesStoolKpiList.vue";
import sithMesStoolOpenPoList from "@/views/sithMes/stool/SithMesStoolOpenPoList.vue";
import sithMesStoolPoCheckerList from "@/views/sithMes/stool/SithMesStoolPoCheckerList.vue";
import sithMesStoolPoCpmList from "@/views/sithMes/stool/SithMesStoolPoCpmList.vue";
import sithMesStoolPoCpmEdit from "@/views/sithMes/stool/SithMesStoolPoCpmEdit.vue";
import sithMesStoolDeliverListEdit from "@/views/sithMes/stool/SithMesStoolDeliverListEdit.vue";
import sithMesStoolDeliverListList from "@/views/sithMes/stool/SithMesStoolDeliverListList.vue";
import sithMesStoolDeliverTaskEdit from "@/views/sithMes/stool/SithMesStoolDeliverTaskEdit.vue";
import sithMesStoolDeliverTaskList from "@/views/sithMes/stool/SithMesStoolDeliverTaskList.vue";
import sithMesStool26StockList from "@/views/sithMes/stool/SithMesStool26StockList.vue";
import sithMesStool26StockEdit from "@/views/sithMes/stool/SithMesStool26StockEdit.vue";
import sithMesStoolGrnTask from "@/views/sithMes/stool/SithMesStoolGrnTask.vue";
import sithMesStoolGrnEdit from "@/views/sithMes/stool/SithMesStoolGrnEdit.vue";
import sithMesStoolGrnList from "@/views/sithMes/stool/SithMesStoolGrnList.vue";
import sithMesStoolPoSdrList from "@/views/sithMes/stool/SithMesStoolPoSdrList.vue";
import sithMesStoolPoSdrEngineerList from "@/views/sithMes/stool/SithMesStoolPoSdrEngineerList.vue";
import sithMesStoolPoSdrEdit from "@/views/sithMes/stool/SithMesStoolPoSdrEdit.vue";
import sithMesNcrProcessVendorTaskList from "@/views/sithMes/stool/SithMesNcrProcessVendorTaskList.vue";
import sithMesStool26StockTransferList from "@/views/sithMes/stool/SithMesStool26StockTransferList.vue";
import sithMesStool26StockTransferEdit from "@/views/sithMes/stool/SithMesStool26StockTransferEdit.vue";
import sithMesStool26StockTransferTask from "@/views/sithMes/stool/SithMesStool26StockTransferTask.vue";
import sithMesStoolVendorList from "@/views/sithMes/stool/SithMesStoolVendorList.vue";
import sithMesStoolVendorEdit from "@/views/sithMes/stool/SithMesStoolVendorEdit.vue";
import sithMesStoolExternalInspectionList from "@/views/sithMes/stool/SithMesStoolExternalInspectionList";
import sithMesStoolExternalInspectionEdit from "@/views/sithMes/stool/SithMesStoolExternalInspectionEdit";
import sithMesStoolRequireDateChangeHistoryList
    from "@/views/sithMes/stool/SithMesStoolRequireDateChangeHistoryList.vue";
import sithMesStoolRequireDateChangeHistoryEdit
    from "@/views/sithMes/stool/SithMesStoolRequireDateChangeHistoryEdit.vue";
import sithMesStoolPurchasingGroupEdit from "@/views/sithMes/stool/SithMesStoolPurchasingGroupEdit";
import sithMesStoolPurchasingGroupList from "@/views/sithMes/stool/SithMesStoolPurchasingGroupList";
import sithMesStoolTransferTicketGenerationRecordEdit
    from "@/views/sithMes/stool/SithMesStoolTransferTicketGenerationRecordEdit.vue";
import sithMesStoolTransferTicketGenerationRecordList
    from "@/views/sithMes/stool/SithMesStoolTransferTicketGenerationRecordList.vue";
import sithMesStoolTransferTicketDetailList from "@/views/sithMes/stool/SithMesStoolTransferTicketDetailList.vue";
import sithMesStoolTransferTicketDetailEdit from "@/views/sithMes/stool/SithMesStoolTransferTicketDetailEdit.vue";
import sithMesStoolPrApplicationIndirectPurchaseDetailEdit
    from "@/views/sithMes/stool/SithMesStoolPrApplicationIndirectPurchaseDetailEdit.vue";
import sithMesStoolPrApplicationIndirectPurchaseDetailList
    from "@/views/sithMes/stool/SithMesStoolPrApplicationIndirectPurchaseDetailList.vue";
import sithMesStoolPrApplicationShippingDetailList
    from "@/views/sithMes/stool/SithMesStoolPrApplicationShippingDetailList.vue";
import sithMesStoolPrApplicationShippingDetailEdit
    from "@/views/sithMes/stool/SithMesStoolPrApplicationShippingDetailEdit.vue";
import sithMesStoolPrApplicationTypeConfigEdit from "@/views/sithMes/stool/SithMesStoolPrApplicationTypeConfigEdit.vue";
import sithMesStoolPrApplicationTypeConfigList from "@/views/sithMes/stool/SithMesStoolPrApplicationTypeConfigList.vue";
import sithMesStoolPrApplicationRecordEdit from "@/views/sithMes/stool/SithMesStoolPrApplicationRecordEdit.vue";
import sithMesStoolPrApplicationRecordList from "@/views/sithMes/stool/SithMesStoolPrApplicationRecordList.vue";
import sithMesStoolPrApplicationRecordTask from "@/views/sithMes/stool/SithMesStoolPrApplicationRecordTask.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/sithMes/stool/sithMesStoolVendorList",
        name: "sithMesStoolVendorList",
        component: sithMesStoolVendorList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolVendorEdit",
        name: "sithMesStoolVendorEdit",
        component: sithMesStoolVendorEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrList",
        name: "sithMesStoolPrList",
        component: sithMesStoolPrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrEdit",
        name: "sithMesStoolPrEdit",
        component: sithMesStoolPrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolOpenPrList",
        name: "sithMesStoolOpenPrList",
        component: sithMesStoolOpenPrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolOpenPrOmList",
        name: "sithMesStoolOpenPrOmList",
        component: sithMesStoolOpenPrOmList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolOpenPrEdit",
        name: "sithMesStoolOpenPrEdit",
        component: sithMesStoolOpenPrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrPoList/list",
        name: "sithMesStoolPrPoListList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrPoList/edit",
        name: "sithMesStoolPrPoListEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoList",
        name: "sithMesStoolPoList",
        component: sithMesStoolPoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTotalPoList",
        name: "sithMesStoolTotalPoList",
        component: sithMesStoolTotalPoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTotalVendorPoList",
        name: "sithMesStoolTotalVendorPoList",
        component: sithMesStoolTotalVendorPoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolKpiList",
        name: "sithMesStoolKpiList",
        component: sithMesStoolKpiList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolOpenPoList",
        name: "sithMesStoolOpenPoList",
        component: sithMesStoolOpenPoList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoCheckerList",
        name: "sithMesStoolPoCheckerList",
        component: sithMesStoolPoCheckerList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoCpmList",
        name: "sithMesStoolPoCpmList",
        component: sithMesStoolPoCpmList,
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoCpmEdit",
        name: "sithMesStoolPoCpmEdit",
        component: sithMesStoolPoCpmEdit,
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolProblematicPrEdit",
        name: "sithMesStoolProblematicPrEdit",
        component: sithMesStoolProblematicPrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolProblematicPrList",
        name: "sithMesStoolProblematicPrList",
        component: sithMesStoolProblematicPrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolHandleProblematicPrList",
        name: "sithMesStoolHandleProblematicPrList",
        component: sithMesStoolHandleProblematicPrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrPriceEdit",
        name: "sithMesStoolPrPriceEdit",
        component: sithMesStoolPrPriceEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrAskPriceList",
        name: "sithMesStoolPrAskPriceList",
        component: sithMesStoolPrAskPriceList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrHistoryPriceList",
        name: "sithMesStoolPrHistoryPriceList",
        component: sithMesStoolPrHistoryPriceList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrPriceList",
        name: "sithMesStoolPrPriceList",
        component: sithMesStoolPrPriceList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolDeliverListEdit",
        name: "sithMesStoolDeliverListEdit",
        component: sithMesStoolDeliverListEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolDeliverListList",
        name: "sithMesStoolDeliverListList",
        component: sithMesStoolDeliverListList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolDeliverTaskEdit",
        name: "sithMesStoolDeliverTaskEdit",
        component: sithMesStoolDeliverTaskEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolDeliverTaskList",
        name: "sithMesStoolDeliverTaskList",
        component: sithMesStoolDeliverTaskList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStool26StockList",
        name: "sithMesStool26StockList",
        component: sithMesStool26StockList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStool26StockEdit",
        name: "sithMesStool26StockEdit",
        component: sithMesStool26StockEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolGrnTask",
        name: "sithMesStoolGrnTask",
        component: sithMesStoolGrnTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolGrnEdit",
        name: "sithMesStoolGrnEdit",
        component: sithMesStoolGrnEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolGrnList",
        name: "sithMesStoolGrnList",
        component: sithMesStoolGrnList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoSdrList",
        name: "sithMesStoolPoSdrList",
        component: sithMesStoolPoSdrList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoSdrEngineerList",
        name: "sithMesStoolPoSdrEngineerList",
        component: sithMesStoolPoSdrEngineerList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPoSdrEdit",
        name: "sithMesStoolPoSdrEdit",
        component: sithMesStoolPoSdrEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesNcrProcessVendorTaskList",
        name: "sithMesNcrProcessVendorTaskList",
        component: sithMesNcrProcessVendorTaskList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStool26StockTransferList",
        name: "sithMesStool26StockTransferList",
        component: sithMesStool26StockTransferList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStool26StockTransferEdit",
        name: "sithMesStool26StockTransferEdit",
        component: sithMesStool26StockTransferEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStool26StockTransferTask",
        name: "sithMesStool26StockTransferTask",
        component: sithMesStool26StockTransferTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolExternalInspectionList",
        name: "sithMesStoolExternalInspectionList",
        component: sithMesStoolExternalInspectionList,
        props: (route) => ({prop_inline: route.query.inline,}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolExternalInspectionEdit",
        name: "sithMesStoolExternalInspectionEdit",
        component: sithMesStoolExternalInspectionEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolRequireDateChangeHistoryList",
        name: "sithMesStoolRequireDateChangeHistoryList",
        component: sithMesStoolRequireDateChangeHistoryList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolRequireDateChangeHistoryEdit",
        name: "sithMesStoolRequireDateChangeHistoryEdit",
        component: sithMesStoolRequireDateChangeHistoryEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPurchasingGroupEdit",
        name: "sithMesStoolPurchasingGroupEdit",
        component: sithMesStoolPurchasingGroupEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPurchasingGroupList",
        name: "sithMesStoolPurchasingGroupList",
        component: sithMesStoolPurchasingGroupList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTransferTicketGenerationRecordEdit",
        name: "sithMesStoolTransferTicketGenerationRecordEdit",
        component: sithMesStoolTransferTicketGenerationRecordEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTransferTicketGenerationRecordList",
        name: "sithMesStoolTransferTicketGenerationRecordList",
        component: sithMesStoolTransferTicketGenerationRecordList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTransferTicketDetailList",
        name: "sithMesStoolTransferTicketDetailList",
        component: sithMesStoolTransferTicketDetailList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolTransferTicketDetailEdit",
        name: "sithMesStoolTransferTicketDetailEdit",
        component: sithMesStoolTransferTicketDetailEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationIndirectPurchaseDetailEdit",
        name: "sithMesStoolPrApplicationIndirectPurchaseDetailEdit",
        component: sithMesStoolPrApplicationIndirectPurchaseDetailEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationIndirectPurchaseDetailList",
        name: "sithMesStoolPrApplicationIndirectPurchaseDetailList",
        component: sithMesStoolPrApplicationIndirectPurchaseDetailList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationShippingDetailList",
        name: "sithMesStoolPrApplicationShippingDetailList",
        component: sithMesStoolPrApplicationShippingDetailList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationShippingDetailEdit",
        name: "sithMesStoolPrApplicationShippingDetailEdit",
        component: sithMesStoolPrApplicationShippingDetailEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationTypeConfigEdit",
        name: "sithMesStoolPrApplicationTypeConfigEdit",
        component: sithMesStoolPrApplicationTypeConfigEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationTypeConfigList",
        name: "sithMesStoolPrApplicationTypeConfigList",
        component: sithMesStoolPrApplicationTypeConfigList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationRecordEdit",
        name: "sithMesStoolPrApplicationRecordEdit",
        component: sithMesStoolPrApplicationRecordEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationRecordList",
        name: "sithMesStoolPrApplicationRecordList",
        component: sithMesStoolPrApplicationRecordList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/stool/sithMesStoolPrApplicationRecordTask",
        name: "sithMesStoolPrApplicationRecordTask",
        component: sithMesStoolPrApplicationRecordTask,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }
//自定义页面注册
]
